<template>
  <div :class="[question?.is_type == 'group' ? 'mb-2' : 'mb-2']">
    <div
      v-if="question?.show_subject !== false"
      class="flex items-start"
    >
      <p
        v-if="!question?.is_html_subject"
        class="text-dark-blue"
      >
        {{ subject }}
      </p>
      <div
        v-else
        class="text-sm"
        v-html="question?.subject"
      />
      <slot />
    </div>
    <p
      v-if="question?.description"
      class="mb-4 text-xxs font-bold uppercase text-gray-over-dark"
    >
      {{ question.description }}
    </p>
    <input
      v-model="answer"
      class="integer-or-float w-full rounded border border-transparent bg-off-white p-4 text-sm hover:border-placeholder-gray focus:bg-white focus:text-dark-gray"
      placeholder=""
      :onkeypress="question.is_type === 'input_integer' ? isInteger : isFloat"
      @input="handleInput"
    />
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    currentTaxFormId: Number,
    onboardingPacketId: Number,
    setTaxAnswers: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
    currentAnswerObject: [Object, Boolean],
  },
  emits: ['child-check', 'group-check'],
  data() {
    return {
      answer: '',
    };
  },
  created() {
    if (this.currentAnswerObject && this.currentAnswerObject !== false) {
      this.answer =
        this.question?.is_type === 'input_integer'
          ? this.currentAnswerObject?.integer_value
          : this.currentAnswerObject?.float_value;
      this.presetSavedAnswer();
    }
  },
  methods: {
    handleInput(e) {
      let type =
        this.question.is_type === 'input_integer'
          ? 'integer_value'
          : 'float_value';

      let body = null;
      if (this.answer?.length > 0) {
        body = {
          onboarding_packet_id: this.onboardingPacketId,
          tax_form_id: this.currentTaxFormId,
          tax_question_id: this.question_id,
          [type]: e.target.value,
        };
      }
      this.setTaxAnswers(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(e.target.value);
    },
    isInteger(e) {
      let charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
      return true;
    },
    isFloat(e) {
      let charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57))
        return false;
      return true;
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (child?.evaluation_js?.length > 0 && child?.tax_question_id > 0) {
            this.$emit(
              'child-check',
              child.tax_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
      if (this.question?.group_parent_id !== null) {
        this.$emit(
          'group-check',
          this.question?.id,
          this.question?.group_parent_id,
          value
        );
      }
    },
    presetSavedAnswer() {
      let type =
        this.question.is_type === 'input_integer'
          ? 'integer_value'
          : 'float_value';
      let body = {
        onboarding_packet_id: this.onboardingPacketId,
        tax_form_id: this.currentTaxFormId,
        tax_question_id: this.question_id,
        [type]: this.answer,
      };
      this.setTaxAnswers(body);
      if (this.required) {
        this.answer
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.answer);
    },
  },
};
</script>
